<!--
 * @Author: wjc
 * @Date: 2023-11-13 17:51:53
 * @LastEditors: wjc
 * @LastEditTime: 2023-11-23 16:20:12
 * @Description: 
-->
<template>
  <el-pagination
    class="m-pagination"
    background
    layout="prev, pager, next"
    prev-text="上一页"
    next-text="下一页"
    :total="total"
    :page-size="pageSize"
    :current-page="currentPage"
    @current-change="handleChange"
  />
</template>

<script setup lang="ts">
  defineOptions({
    name: 'MPagination',
  })

  const props = withDefaults(
    defineProps<{
      total: number
      pageSize: number
      currentPage: number
    }>(),
    {
      total: 50,
      pageSize: 10,
      currentPage: 1,
    }
  )
  const emits = defineEmits<{
    (e: 'change', value: number): void
  }>()

  const handleChange = (value: number) => {
    emits('change', value)
  }
</script>

<style scoped lang="scss">
  .m-pagination {
    --el-pagination-hover-color: var(--bg-color-light);
    :deep(.el-pager) {
      li.is-active {
      }
      li {
        @apply mx-4px;
      }
    }
  }
</style>
